module.exports = {"CARDS":{"NEW":{"TITLE":"Nuove carte","NO_NEW_CARDS":"Non ci sono nuove carte"},"CARD_NUMBER":"Carta No","CARD_PROGRAM":"Card Program","CURRENCY":"Valuta","SHORT_NUMBER":"Numero breve","CARD_VALIDITY":"Validità della carta"}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/it/cards.json
// module id = 726
// module chunks = 0